import moment from "moment";

export class User {
  UserID;
  EngName;
  ChiName;
  Pwd;
  ConfirmPwd; //Front-end only
  JobTitle;
  SupervisorID;
  Lang;
  DefOutputPath;
  MobilePhone;
  WorkPhone;
  IDNum;
  PhotoPath;
  IMEI;
  RecDel;
  DateResign;
  StaffGrade;
  EmpRef;
  Dept;
  TeamCode;
  DateAdd;
  DateJoin;
  Acting;
  NotificationRef;
  RosterBase;
  Email;
  UserGrps;
  DeptsAlw;
  constructor() {
    this.UserID = "";
    this.EngName = "";
    this.ChiName = "";
    this.Pwd = "";
    this.ConfirmPwd = "";
    this.JobTitle = "";
    this.SupervisorID = "";
    this.Lang = "EN";
    this.DefOutputPath = "";
    this.MobilePhone = "";
    this.WorkPhone = "";
    this.IDNum = "";
    this.PhotoPath = "";
    this.IMEI = "";
    this.Dept = "";
    this.TeamCode = "";
    this.RecDel = false;
    this.StaffGrade = "";
    this.EmpRef = "";
    this.DateResign = moment("1900-01-01").format("YYYY-MM-DD");
    this.DateAdd = moment().format("YYYY-MM-DD");
    this.DateJoin = moment().format("YYYY-MM-DD");
    this.Acting = "";
    this.NotificationRef = false;
    this.RosterBase = false;
    this.Email = "";
    this.UserGrps = [];
    this.DeptsAlw = [];
  }
}



// WEBPACK FOOTER //
// ./src/model/User.js